module.exports = __webpack_public_path__ + "img/kl_logo.af2b0bc0.png";